// extracted by mini-css-extract-plugin
module.exports = {"products":"Products_products__t7_rk","imgScale":"Products_imgScale__zSxsA","imgScale2":"Products_imgScale2__j401m"};